const layout = () => import(/* webpackChunkName: "layout" */ '@/components/layout');

export default [
  {
    path: '',
    component: layout,
    children: [
      {
        name: 'mallHomePage',
        component: () => import(/* webpackChunkName: "b2b_homepage" */ '@/pages/mallHomePage'),
        meta: {
          title: '首页'
        },
        path: '/mallHomePage',
        children: [
          {
            name: 'all',
            component: () => import(/* webpackChunkName: "b2b_homepage_all" */ '@/pages/mallHomePage/all'),
            meta: {
              title: '全部分类'
            },
            path: 'all'
          },
          {
            name: 'storeList',
            component: () =>
              import(/* webpackChunkName: "b2b_homepage_storeList" */ '@/pages/mallHomePage/storeList/index.vue'),
            meta: {
              title: '店铺列表'
            },
            path: 'storeList'
          },
          {
            name: 'goodsList',
            component: () =>
              import(/* webpackChunkName: "b2b_homepage_goodsList" */ '@/pages/mallHomePage/goodsList/index.vue'),
            meta: {
              title: '商品列表'
            },
            path: 'goodsList'
          }
        ]
      }
    ]
  },
  {
    name: 'login',
    component: () => import(/* webpackChunkName: "b2b_login" */ '@/pages/login'),
    meta: {
      title: '登录页'
    },
    path: '/login'
  }
];
